module.exports = __webpack_public_path__ + "static/img/アセット 32@2x.4c426fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 32@2x.png
// module id = Jv4a
// module chunks = 1